import { PendenciasModal } from '@core/components/PendenciasCobranca';
import React from 'react';
import { ContratoAction, useContrato } from '../../store';

const ContratoVisualizacaoModal = () => {
  const [state, dispatch] = useContrato();
  const { visualizarPendencias, pendencias } = state;

  const handleCancelar = () => ContratoAction.showHideModalPendencia(dispatch, false);

  return <PendenciasModal show={visualizarPendencias} pendencias={pendencias} onClose={handleCancelar} />;
};

export default ContratoVisualizacaoModal;
